import React from 'react'
import { HeaderEl } from '../Elements'
import { H4, H6 } from '../../../../../../../Styles/typography'
import { withRouter } from 'react-router-dom'

function Header({
  courseDetails: { cover, name, teacher, courseURL, livDemyID },
  history,
}) {
  return (
    <HeaderEl cover={cover}>
      <div
        className='cover'
        onClick={() => history.push(`/${livDemyID}/course/${courseURL}`)}
      />
      <div className='info'>
        <H4 onClick={() => history.push(`/${livDemyID}/course/${courseURL}`)}>
          {name}
        </H4>
        <H6>
          By{' '}
          <span onClick={() => history.push(`/${livDemyID}`)}>
            {teacher.name}
          </span>
        </H6>
      </div>
    </HeaderEl>
  )
}

export default withRouter(Header)
